import wixUsers from 'wix-users';
import wixLocation from 'wix-location';

$w.onReady(function () {
	
	$w("#1goto2").onClick((event)=>{
		$w("#statebox8").changeState("second"); 
	})

	$w("#1goto3").onClick((event)=>{
		$w("#statebox8").changeState("third"); 
	})

	$w("#1goto4").onClick((event)=>{
		$w("#statebox8").changeState("fourth"); 
	})
	$w("#2goto1").onClick((event)=>{
		$w("#statebox8").changeState("first"); 
	})
	$w("#2goto3").onClick((event)=>{
		$w("#statebox8").changeState("third"); 
	})
	$w("#2goto4").onClick((event)=>{
		$w("#statebox8").changeState("fourth"); 
	})
	$w("#3goto1").onClick((event)=>{
		$w("#statebox8").changeState("first"); 
	})
	$w("#3goto2").onClick((event)=>{
		$w("#statebox8").changeState("second"); 
	})
	$w("#3goto4").onClick((event)=>{
		$w("#statebox8").changeState("fourth"); 
	})
	$w("#4goto1").onClick((event)=>{
		$w("#statebox8").changeState("first"); 
	})
	$w("#4goto2").onClick((event)=>{
		$w("#statebox8").changeState("second"); 
	})
	$w("#4goto3").onClick((event)=>{
		$w("#statebox8").changeState("third"); 
	})
})